import {GrowlType} from "../../../layout/components/growl/@types";


export default class Growl {
    public id         : ID
    public type       : GrowlType
    public message    : any
    public isSticky   : boolean = false
    public selfDestroy: boolean = true

    constructor(data: any) {

        this.id          = data["id"]
        this.type        = data["type"]
        this.message     = data["message"]
        this.isSticky    = data["isSticky"]
        this.selfDestroy = data["selfDestroy"]

    }

}


// import AmpersandSate from 'ampersand-state';
//
// module.exports = AmpersandSate.extend({
//
//     props: {
//         id: 'string',
//         type: 'any',
//         message: 'any',
//         isSticky: { // sticky = doesn't dissapear when go to next page
//             type: 'boolean',
//             default: false
//         },
//         selfDestroy: { // self destroy within XXX seconds
//             type: 'boolean',
//             default: true
//         }
//     }
// });
